import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const EXPORT_BASE = 'export-base'

export default {
  [PORTUGUESE]: {
    [EXPORT_BASE]: 'Base de Exportação',
  },

  [ENGLISH]: {
    [EXPORT_BASE]: 'Export Base',
  },

  [SPANISH]: {
    [EXPORT_BASE]: 'Base de Exportación',
  },
}
